export default __webpack_public_path__ + "static/media/croptop-small-right-toobig.88b8a3a5.jpg";